import React, { useEffect, useState } from 'react';

/**
 * Tiny "עודכן לפני X שניות/דקות" indicator. Updates itself once a
 * second so the elapsed text stays fresh between live-poll ticks.
 *
 * Props:
 *   timestamp — JS Date or epoch ms of the last successful refresh
 *               (null/undefined → shows nothing, so the parent can mount
 *               us unconditionally before its first /live response).
 */
function LiveUpdatedAt({ timestamp, style }) {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick(t => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  if (!timestamp) return null;
  const t = typeof timestamp === 'number' ? timestamp : timestamp.getTime();
  const secs = Math.max(0, Math.floor((Date.now() - t) / 1000));

  let label;
  if (secs < 5) label = 'עודכן זה עתה';
  else if (secs < 60) label = `עודכן לפני ${secs} שניות`;
  else if (secs < 3600) {
    const m = Math.floor(secs / 60);
    label = `עודכן לפני ${m} ${m === 1 ? 'דקה' : 'דקות'}`;
  } else {
    const h = Math.floor(secs / 3600);
    label = `עודכן לפני ${h} ${h === 1 ? 'שעה' : 'שעות'}`;
  }

  return (
    <span style={{
      fontSize: '0.75rem',
      color: '#6b7280',
      ...style,
    }}>
      <span style={{
        display: 'inline-block',
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: secs < 60 ? '#22c55e' : '#9ca3af',
        marginInlineEnd: '0.35rem',
        verticalAlign: 'middle',
      }} aria-hidden="true" />
      {label}
    </span>
  );
}

export default LiveUpdatedAt;
